import { render, staticRenderFns } from "./Vulnerability.vue?vue&type=template&id=ef67d622&scoped=true"
import script from "./Vulnerability.vue?vue&type=script&lang=js"
export * from "./Vulnerability.vue?vue&type=script&lang=js"
import style0 from "./Vulnerability.vue?vue&type=style&index=0&id=ef67d622&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef67d622",
  null
  
)

export default component.exports